import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, map, shareReplay, takeUntil } from 'rxjs';
import { AuthService } from '@app/shared/auth/auth.service';
import { User } from '@app/shared/models/user-info.model';
import { Align, Size } from '@app/shared/components/atoms/icon/icon.component';
import { Color } from '@app/shared/models/color.model';
import { SidenavComponent } from '@app/shared/components/molecules/sidenav/sidenav.component';
import { environment } from '@environments/environment';
import { APP_VERSION } from '@environments/version';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements OnInit, OnDestroy {
  unsubscribe$: Subject<boolean> = new Subject<boolean>();

  userConnected?: User;

  environment = environment.ENV;

  protected readonly appVersion = APP_VERSION;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
    map((result) => result.matches),
    shareReplay(),
  );

  @Input() isMenuOpen: boolean = false;

  @Input() sidenav!: SidenavComponent;

  protected readonly Size = Size;

  constructor(
    private authentication: AuthService,
    private breakpointObserver: BreakpointObserver,
    private elementRef: ElementRef,
  ) {}

  ngOnInit(): void {
    this.authentication.connectedUser$.pipe(takeUntil(this.unsubscribe$)).subscribe((user) => {
      if (user) this.userConnected = user;
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.isMenuOpen && !this.elementRef.nativeElement.contains(event.target)) {
      this.isMenuOpen = false;
    }
  }

  protected readonly Align = Align;
  protected readonly Color = Color;
}
